export default {
    modal_move: {
        status: 'Move Status - {{title}}',
        ticket: 'Move Ticket - {{title}}',
        all_tickets: 'Move All Tickets with Status - {{title}}'
    },
    error: {
        move_tickets: 'Unable to move the following tickets',
        archive_tickets: 'Unable to archive the following tickets',
    },
    alert: {
        archive_all_tickets_title: 'Do you want to archive all tickets with status {{status}}?',
        archive_all_tickets_text: 'After archiving tickets, it will no longer be possible to update them.',
    },
}
